module.exports = __webpack_public_path__ + "img/online_title.b79b2025.png";